/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Youtube_Region_7Inputs */



/**
* | output |
* | --- |
* | "Bottom left" |
*
* @param {Live_Caption_Youtube_Region_7Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_youtube_region_7 = /** @type {((inputs?: Live_Caption_Youtube_Region_7Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Youtube_Region_7Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En bas à gauche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Unten links")
	if (locale === "it") return /** @type {LocalizedString} */ ("In basso a sinistra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Внизу слева")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abajo a la izquierda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("左下角")
	if (locale === "ja") return /** @type {LocalizedString} */ ("左下")
	if (locale === "hi") return /** @type {LocalizedString} */ ("तली छोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Canto inferior esquerdo")
	return /** @type {LocalizedString} */ ("Bottom left")
});